// extracted by mini-css-extract-plugin
export default {"container":"JP-z","darkBackground":"KP-z","whiteBackground":"LP-z","headerButton":"MP-z","calloutHeading":"NP-z","calloutSubHeading":"OP-z"};